import SwitchDevice from "./SwitchDevice"

export default SwitchDevice
